import $ from 'jquery' // jQuery

// 各importリンクはAlt+クリックで直接そのファイルを開きます（VSCodeの場合）

import './module/_hashScroll.js' // アンカーリンクスクロール
import './module/_spMenuToggle.js' // SPメニュー開閉

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper, Scrollbar } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, Scrollbar]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

// ビジュアル関連
import './module/_inAnimation.js' // 画面に入った要素のアニメーション
// import './module/_modal.js' // モーダル
// import './module/_youtube.js' // YouTubeAPI
import './module/_inCount.js' // 画面に入った数値のカウントアップ演出
// import './module/_hoverSync.js' // マウスホバー状態の同期
// import './module/_destroyParent.js' // .js-destroyParentを押すと親の.js-destroyParent-frameを消す

// フォーム関連
// import './module/_validation.js' // バリデーション処理
// import './module/_zipAddress.js' // 郵便番号から住所検索
// import './module/_datePicker.js' // 日付入力
// import './module/_browserBackReplace.js' // 確認画面等のブラウザバック操作差し替え
// import './module/_selectJump.js' // セレクトボックスによるページ遷移

// ページ関連
import './_top.js'
import './_news.js'
import './_inquiry.js'
import './_group.js'
import './_social.js'
import './_secNav.js'
import './_achievements.js'
import './_recruit.js'

// コードストック
/* global  */ // tUrl等のグローバル変数を宣言する 「/* global tUrl */」でフッターにあるtUrlが使える

/*
Swiper使用時のインポート文

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,
*/

//  ##   ##  #####    ###    ####    #####  #####
//  ##   ##  ##      ## ##   ##  ##  ##     ##  ##
//  #######  #####  ##   ##  ##  ##  #####  #####
//  ##   ##  ##     #######  ##  ##  ##     ##  ##
//  ##   ##  #####  ##   ##  ####    #####  ##   ##


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.headerPulldown').forEach(function (pulldown) {
    let timeoutId

    pulldown.addEventListener('mouseenter', function () {
      clearTimeout(timeoutId)

      let head = pulldown.querySelector('.js-headerPulldown__head')
      let body = pulldown.querySelector('.js-headerPulldown__body')

      if (head) head.classList.add('is_active')
      if (body) body.classList.add('is_active')
    })

    pulldown.addEventListener('mouseleave', function () {
      timeoutId = setTimeout(function () {
        let head = pulldown.querySelector('.js-headerPulldown__head')
        let body = pulldown.querySelector('.js-headerPulldown__body')

        if (head) head.classList.remove('is_active')
        if (body) body.classList.remove('is_active')
      }, 300)
    })
  })



  const toTopButton = document.querySelector(".js-header");
  if (!toTopButton) return;

  let ticking = false;

  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        let wt = window.scrollY;
        toTopButton.classList.toggle("is_fixed", wt > 200);
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener("load", handleScroll);
  window.addEventListener("scroll", handleScroll);
})

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.acc-btn').forEach((button) => {
    button.addEventListener('click', function () {
      const body = this.nextElementSibling
      this.classList.toggle('is_active')
      if (body.classList.contains('open')) {
        body.style.maxHeight = null
      } else {
        body.style.maxHeight = body.scrollHeight + 'px'
      }
      body.classList.toggle('open')
    })
  })
})

document.addEventListener('DOMContentLoaded', function () {
  const footer = document.querySelector('.js-footer')
  const header = document.querySelector('.js-header')

  if (!footer || !header) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          header.classList.add('is_none')
        } else {
          header.classList.remove('is_none')
        }
      })
    },
    {
      threshold: 0.5,
    } // フッターの10%以上が見えたら反応
  )

  observer.observe(footer)
})






document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".js-fadeIn");

  const onScroll = () => {
      elements.forEach(el => {
          const rect = el.getBoundingClientRect();
          const windowHeight = window.innerHeight;

          if (rect.top < windowHeight * 0.9) {
              el.classList.add("is-visible");
          }
      });
  };

  window.addEventListener("scroll", onScroll);
  onScroll(); // 初回チェック（すでに見えている場合）
});
